// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"ad1c85c044bcbb964ae4","293":"99e9ac9b7ff100adbece","522":"5d9500e97ac3808b9a4f"}[chunkId] + ".js";
};